import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddTransportMutation, useDeleteTransportMutation, useEditTransportMutation } from "../../../../redux/api/transport/transportApi";
import { EntTransport } from "../../../../models/transport";
import { getCookie } from "typescript-cookie";

const useTransport = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addTransport] = useAddTransportMutation();
    const [deleteTransport] = useDeleteTransportMutation();
    const [editTransport] = useEditTransportMutation();

    async function onAddTransport(newTransport: EntTransport): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTransport(newTransport).then((response: any) => {
                  if (response.error) {
                                 const isKyrgyz = getCookie('i18next') === 'ky';
                                 const lang = isKyrgyz ? 'kg' : 'ru';
                                 const res = response.error.data?.res;
                                 const errorMessages = Array.isArray(res)
                                     ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                     : response.error.data?.msg || t('unknownError'); 
                                 throw new Error(errorMessages);
                             }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTransport(transport: EntTransport) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTransport(transport.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditTransport(editedTransport: EntTransport): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTransport(editedTransport).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddTransport, onDeleteTransport, onEditTransport };
}

export { useTransport };
